import React, {useEffect, useState} from "react";
import {HTTP_ERROR_CODES, HTTP_ERROR_INFO} from "../constants/error";
import useDocumentTitle from "../hooks/useDocumentTitle";
import {SpanEnv} from "../components/labels";
import {HeaderTenkenTitle, HeaderUsersTitle} from "../components/admin";
import {isAuthenticated} from "../services";
import {useNavigate} from "react-router-dom";
import {DASHBOARD, HOME, USERS_DASHBOARD} from "../constants/routes";
import {Button} from "../components"
import tenkenTheme from "../configs/themes/tenkenTheme";
import {ENV} from "../configs/settings";

export default function ErrorPage(props) {
  const errorInfo = HTTP_ERROR_INFO[props.errorCode];
  const navigate = useNavigate();
  const [errorDetail, setErrorDetail] = useState('');
  const [backUrl, setBackUrl] = useState(DASHBOARD);

  useEffect(() => {
    const getErrorDetail = localStorage.getItem('errorDetail');
    const getBackUrl = localStorage.getItem('backUrl');
    if (getErrorDetail) {
      setErrorDetail(getErrorDetail);
      localStorage.removeItem('errorDetail');
    }
    if (getBackUrl) {
      setBackUrl(getBackUrl);
      localStorage.removeItem('backUrl');
    }
  }, []);

  useDocumentTitle(errorInfo.documentTitle);
  const tmpProps = {
    ...props,
    theme: tenkenTheme.button,
    color: "primary",
    className: `rounded-[6px] min-w-[140px] h-[40px]`,
  };

  const handleBack = () => {
    if (isAuthenticated()) {
      navigate(backUrl);
    } else {
      navigate(HOME);
    }
  };

  const Header = () => {
    if (isAuthenticated()) {
      if (backUrl === USERS_DASHBOARD) {
        return (
          <header className="flex justify-between py-[12px] px-[24px] relative bg-[#1D1D1D]">
            <SpanEnv className="top-[12px]"/>
            <HeaderUsersTitle/>
          </header>
        )
      } else {
        return (
          <header className="flex justify-between py-[12px] px-[24px] relative bg-[#111D3A]">
            <SpanEnv className="top-[12px]"/>
            <HeaderTenkenTitle/>
          </header>
        )
      }
    }
    return (
      <nav className="tenken__header-shadow">
        <div className="mx-auto xl:w-[1040px] md:w-[750px] xl:h-20 md:h-16 relative">
          <div
            className="float-left xl:h-20 md:h-16 flex items-center font-bold text-black xl:text-[32px] md:text-[30px]">
            点検王
          </div>
          <div className="float-right xl:h-20 md:h-16 flex items-center">
            <SpanEnv className="top-[20px]"/>
          </div>
        </div>
      </nav>
    )
  };

  return (
    <div className="w=full">
      {Header()}
      <div className="flex mt-20 items-center justify-center">
        <div
          className="flex flex-col justify-center items-center bg-white 2xl:p-10 xl:p-8 md:p-6 border border-[#e0e0e0] rounded-[8px] space-y-2">
          {props.errorCode === HTTP_ERROR_CODES.INTERNAL_SERVER_ERROR ? (
            <p className="text-gray-900 text-[22px] text-center">エラーが発生したため、処理を中断しました。<br/>ご不便をおかけし申し訳ございません。</p>
          ) : (
            <p className="text-gray-900 text-[22px] text-center">{errorInfo.message}</p>
          )}
          <h1 className="xl:text-[80px] md:text-[50px] font-bold text-gray-900">{props.errorCode}</h1>
          <p className="text-gray-900 font-bold text-[22px] pb-6 xl:pb-10">{errorInfo.title}</p>
          <Button {...tmpProps} onClick={handleBack}>
            ホームに戻る
          </Button>

          {props.errorCode === 500 && errorDetail && ENV !== 'production' && (
            <div className="flex flex-col w-full space-y-2 !mt-8">
              <p className="text-gray-900 text-[18px] text-center font-medium">以下のような原因が考えられます。</p>
              <div className="w-full bg-red-100 border border-[#FFFFFF] p-4">
                <p className="text-red-500 text-[16px]">{errorDetail}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
